// Slice size options.
export const sliceSize = [[970, 90], [728, 90], [320, 50]];

// Slice sizemapping.
export const sliceMap = [
  [[1024, 1], [[970, 90]]],
  [[768, 1], [[728, 90]]],
  [[320, 1], [[320, 50]]],
];

// Slot size options.
export const slotSize = [[300, 250]];

// Slot sizemapping.
export const slotMap = [
  [[1024, 1], [[300, 250]]],
  [[768, 1], [[300, 250]]],
  [[320, 1], [[300, 250]]],
];
